import { menuItemsMakers } from "./menuItemsMakers";
export const menuItemsPrintRich = [
    // {
    //     "children": [
    //         {
    //             "children": [
    //                 {
    //                     "children": [
    //                         {
    //                             "children": [
    //                                 {
    //                                     "title": "2b.....Indian features.com.pdf",
    //                                     "type": "file"
    //                                 }
    //                             ],
    //                             "title": "PDF",
    //                             "type": "directory"
    //                         }
    //                     ],
    //                     "title": "CATALOG",
    //                     "type": "directory"
    //                 }
    //             ],
    //             "title": "INDIAN FEATURES",
    //             "type": "directory"
    //         },
    //         {
    //             "children": [
    //                 {
    //                     "children": [
    //                         {
    //                             "title": "ALL IN ONE CATALOGUE.pdf",
    //                             "type": "file"
    //                         }
    //                     ],
    //                     "title": "CATALOG",
    //                     "type": "directory"
    //                 }
    //             ],
    //             "title": "PRINTING RIGHTS",
    //             "type": "directory"
    //         },
    //         {
    //             "children": [
    //                 {
    //                     "children": [
    //                         {
    //                             "children": [
    //                                 {
    //                                     "title": "TAL_FINAL CATALOGUE (1).pdf",
    //                                     "type": "file"
    //                                 }
    //                             ],
    //                             "title": "PDF",
    //                             "type": "directory"
    //                         }
    //                     ],
    //                     "title": "CATALOG",
    //                     "type": "directory"
    //                 }
    //             ],
    //             "title": "TAL_FINAL",
    //             "type": "directory"
    //         }
    //     ],
    //     "title": "PUBLISHING",
    //     "type": "directory"
    // }
     {
         "title": "All",
        "type": "directory",
    },
     {
         "title": "Stories",
        "type": "directory",
    },
     {
         "title": "pictorial stories",
        "type": "directory",
    },
     {
         "title": "Comics",
        "type": "directory",
    },
     {
         "title": "Bio graphics",
        "type": "directory",
    },
     {
         "title": "Life lessons",
        "type": "directory",
    },
     {
         "title": "Comic strips",
        "type": "directory",
    },
       {
         "title": "Bloopers",
        "type": "directory",
    },
       {
         "title": "More...",
        "type": "directory",
    },
]
// .concat(menuItemsMakers) we are hidding this line from above line it was like this ].concat(menuItemsMakers)  but we are hidding bz it was showing in all icons